export function BeforeFooter() {
  return null;
}
